import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';

/**
 * The tone vocabulary the non-chart widgets share.
 *
 * One map, so a "critical" alert row, a "critical" board column and a
 * "critical" stat are the same red with the same icon. Six copies of a
 * `variant === 'error' ? …` ternary is how three widgets end up disagreeing
 * about what critical looks like.
 *
 * `bg` / `icon` are `IconHighlight`'s own PascalCase token names — passing a
 * name it does not know (`Grey`, `Orange`) makes it paint the icon the same
 * colour as its background, which renders as a blank tile.
 *
 * `text` is the same tone as a text colour, for the figures that carry their
 * verdict in the type rather than in a badge — a metric's delta, a KPI's
 * comparison. It is a class and not a token because Tailwind needs the whole
 * class name to be present in the source to emit it.
 */
export const STAT_TONES = Object.freeze({
  neutral: Object.freeze({ bg: 'Neutral', icon: 'Primary', badge: 'neutral', defaultIcon: Info, text: 'text-content' }),
  info: Object.freeze({ bg: 'Primary', icon: 'PrimaryAlt', badge: 'informative', defaultIcon: Info, text: 'text-blue-600 dark:text-blue-400' }),
  success: Object.freeze({ bg: 'Success', icon: 'Green', badge: 'success', defaultIcon: CheckCircle2, text: 'text-emerald-600 dark:text-emerald-400' }),
  warning: Object.freeze({ bg: 'Alert', icon: 'Alert', badge: 'alert', defaultIcon: AlertTriangle, text: 'text-amber-600 dark:text-amber-400' }),
  critical: Object.freeze({ bg: 'Error', icon: 'Error', badge: 'error', defaultIcon: XCircle, text: 'text-red-600 dark:text-red-400' }),
});

/** A tone entry by name, falling back to neutral rather than rendering blank. */
export const toneFor = (name) => STAT_TONES[name] ?? STAT_TONES.neutral;

export default STAT_TONES;
